import { LuTrophy } from 'react-icons/lu';
import './RankingsTable.css';

function getWinCount(player) {
  return player.tournaments?.filter((t) => t.placement === 1).length || 0;
}

function isWinner(player) {
  return getWinCount(player) > 0;
}

function isQualified(player, invitational, allRankings) {
  if (!invitational) return false;

  // Winners are always qualified (but shown with trophy badge, not "Qualifié")
  if (invitational.autoQualifyWinners && isWinner(player)) {
    return true;
  }

  if (invitational.qualificationType === 'points') {
    return player.totalPoints >= invitational.threshold;
  }

  if (invitational.qualificationType === 'rank') {
    let effectiveThreshold = invitational.threshold;

    // When autoQualifyWinners is on, winners already qualified don't consume
    // a rank slot. Count how many winners exist within the expanded range
    // and add that to the threshold.
    if (invitational.autoQualifyWinners && allRankings) {
      let winnersInRange = 0;
      let currentThreshold = effectiveThreshold;

      // Iteratively expand: each winner found within the threshold shifts it up by 1
      for (const p of allRankings) {
        if (p.rank > currentThreshold) break;
        if (isWinner(p)) {
          winnersInRange++;
          currentThreshold = invitational.threshold + winnersInRange;
        }
      }

      effectiveThreshold = currentThreshold;
    }

    // Get the points of the last qualified player (not winners)
    let lastQualifiedPoints = null;
    for (const p of allRankings) {
      if (p.rank <= effectiveThreshold && !isWinner(p)) {
        lastQualifiedPoints = p.totalPoints;
      }
    }

    // Include players who are within rank threshold OR
    // are below threshold but have same points as the last qualified non-winner
    if (player.rank <= effectiveThreshold) {
      return true;
    }
    if (lastQualifiedPoints !== null && player.totalPoints === lastQualifiedPoints && !isWinner(player)) {
      return true;
    }

    return false;
  }

  return false;
}

export default function RankingsTable({ rankings, invitational }) {
  if (!rankings || rankings.length === 0) {
    return (
      <div className="rankings-empty chiron-goround-tc-body">
        <p>Aucun classement disponible pour le moment.</p>
      </div>
    );
  }

  return (
    <div className="rankings-table-wrapper">
      <table className="rankings-table">
        <thead>
          <tr>
            <th className="staatliches-regular">#</th>
            <th className="staatliches-regular">Joueur</th>
            <th className="staatliches-regular">Points</th>
            <th className="staatliches-regular rankings-table__hide-mobile">Tournois</th>
            <th className="staatliches-regular">Statut</th>
          </tr>
        </thead>
        <tbody>
          {rankings.map((player) => (
            <tr key={player.rank} className={player.rank <= 3 ? 'rankings-table__top' : ''}>
              <td className="rankings-table__rank">
                <span className={`rankings-table__rank-badge rankings-table__rank-badge--${player.rank <= 3 ? player.rank : 'default'}`}>
                  {player.rank}
                </span>
              </td>
              <td className="rankings-table__name chiron-goround-tc-bold">{player.name}</td>
              <td className="rankings-table__points staatliches-regular">{player.totalPoints}</td>
              <td className="rankings-table__tournaments rankings-table__hide-mobile chiron-goround-tc-body">
                {player.tournaments?.length || 0}
              </td>
              <td className="rankings-table__status">
                {isWinner(player) ? (
                  <span className="rankings-table__trophy staatliches-regular">
                    <LuTrophy className="rankings-table__trophy-icon" />
                    {getWinCount(player)}
                  </span>
                ) : isQualified(player, invitational, rankings) ? (
                  <span className="rankings-table__qualified staatliches-regular">Qualifié</span>
                ) : (
                  <span className="rankings-table__not-qualified chiron-goround-tc-light">-</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
